import { EgpRegionAndCountry } from '../egp.service';

import { Pipe, PipeTransform } from '@angular/core';

import { isNil } from 'src/utils/utils';

@Pipe({
  name: 'showMoreDays',
  standalone: true,
})
export class ShowMoreDaysPipe implements PipeTransform {
  transform(region: EgpRegionAndCountry): boolean {
    if (
      isNil(region?.country) ||
      (region.country !== 'de' && region.country !== 'ch')
    ) {
      return false;
    }
    return true;
  }
}
